import { element } from 'protractor';
import { DatePipe } from '@angular/common';
import { TotalsRequestDTO } from './../@core/models/home-models';
import { PanelStore } from './../requests/panel/panel.store';
import { CommonDataDTO } from './../requests/model/combos-model';
import { HomeService } from './home.service';
import { Component, OnInit } from '@angular/core';
import { Credentials } from '@app/@core/models/login-models';
import { AuthenticationService } from '../@core/auth/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { AgentDTO } from '@app/requests/model/requests-model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { forkJoin } from 'rxjs';
import { UserAttributionsEnum, UserFranchise } from '@app/@core/constants/user-credentials.constants';
import { CredentialsService } from '@app/login';
import { Router } from '@angular/router';
import { HomeObject, TotalOperationsDTO } from '@app/@core/models/home-models';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { SearchStore } from '@app/users/operation-search/search-store';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MEDIA_BREAKPOINTS } from '@app/@core/media.config';
import { admin, seller, Tamanhos } from './sizes';
import {
  URL_REQUESTS_CALCULATOR,
  URL_REQUESTS_CALCULATOR_AUTOS,
  URL_REQUESTS_PANEL,
  URL_REQUESTS_REQUEST,
  URL_REQUESTS_REQUEST_AUTOS,
  URL_REQUESTS_REQUEST_BP,
  URL_REQUESTS_REQUEST_CG,
  URL_REQUESTS_REQUEST_MG,
  URL_REQUESTS_REQUEST_MG_NO_SHOPPING,
} from '@app/@core/constants/routes.constants';
import {
  ABONADAS_PENDIENTES_DE_VALIDACION,
  APROBADAS,
  EN_ESTUDIO,
  FORMALIZADAS_ABONADAS_VALIDADAS,
  PENDIENTES_DE_DATOS,
  PENDIENTES_PAGO_POR_INCIDENCIAS,
  FIRMADAS,
} from '@app/@core/constants/requests.constants';
const DATE_FORMAT_YYYY_MM_DD = 'yyyy-MM-dd';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  buttonsList: HomeObject[] = [];
  attributions: string[];
  establishmentData: CommonDataDTO[];
  commercialProductList: CommonDataDTO[];
  lineProductList: CommonDataDTO[];
  latestRequestCols: number = 2;

  public userName: string;
  public isWarning: boolean;
  public isLoading: boolean;
  public buttonEnabled: boolean;
  public searchButtonEnabled: boolean;
  public isMango: boolean;
  public isRepsol: boolean;
  public isBonpreu: boolean;
  public isRenault: boolean = false;
  public isAural: boolean = false;
  public isWidex: boolean = false;
  public canSearchOperations: boolean = false;

  public calculatorForm: FormGroup;
  public searchForm: FormGroup;

  agentDTOUser: AgentDTO;
  userInfo: Credentials;

  private isOperationsFinishedLoading: boolean = false;
  private isEstablishmentFinishedLoading: boolean = false;
  private isLineCommercialFinishedLoading: boolean = true;

  public gridSizes: Tamanhos;
  tamanho: number = 0;
  showRequestsCard: boolean = false;
  showNewRequestCard: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService,
    private formBuilder: FormBuilder,
    private combosStore: CombosStore,
    private translate: TranslateService,
    private customValidators: CustomValidatorsService,
    private homeService: HomeService,
    private dialog: MatDialog,
    private router: Router,
    private panelStore: PanelStore,
    private loaderGenericService: LoaderGenericService,
    private searchStore: SearchStore,
    private datePipe: DatePipe,
    private breakpointObserver: BreakpointObserver
  ) {
    this.loaderGenericService.showSpinner();

    let dataString: string = localStorage.getItem('credentials');
    this.userInfo = JSON.parse(dataString);

    this.attributions = this.userInfo.attribIds; //this.authenticationService.getUserAttributions();
    let attributionsUrl = this.userInfo.urls; //this.authenticationService.getUserUrlAttributions();
    console.log(attributionsUrl);

    this.userName = this.userInfo.username;
    console.log('Userinfo', this.userInfo);

    if (this.userInfo.franchise?.toUpperCase() === UserFranchise.AURAL) this.isAural = true;
    if (this.userInfo.franchise?.toUpperCase() === UserFranchise.WIDEX) this.isWidex = true;
    if (this.userInfo.franchise?.toUpperCase() === UserFranchise.RENAULT) this.isRenault = true;

    this.agentDTOUser = {
      division: this.userInfo.division,
      typeUser: this.userInfo.userType === 'V' ? this.userInfo.parentType : this.userInfo.userType,
      userId: this.userInfo.userType === 'V' ? this.userInfo.parentId : this.userInfo.userId,
    };

    if (this.attributions.includes(UserAttributionsEnum.ATTR_SEARCH_OPERATION)) {
      this.isMango = false;
      this.isBonpreu = false;
      this.isRepsol = false;
      this.canSearchOperations = true;
    } else if (
      this.attributions.includes(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) ||
      this.attributions.includes(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG)
    ) {
      this.isMango = true;
    } else if (this.attributions.includes(UserAttributionsEnum.ATTR_ALTA_BP)) {
      this.isBonpreu = true;
    } else if (this.attributions.includes(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS)) {
      this.isRepsol = true;
    }

    if (this.agentDTOUser.typeUser === 'A') {
      this.gridSizes = admin;
    } else {
      this.gridSizes = seller;
    }
    console.log(this.gridSizes);
  }

  ngOnInit() {
    this.isWarning = false; //TODO: esto se llamara con un servicio, de momento se oculta

    this.breakpointObserver
      .observe([
        MEDIA_BREAKPOINTS.XS,
        MEDIA_BREAKPOINTS.SM,
        MEDIA_BREAKPOINTS.MD,
        MEDIA_BREAKPOINTS.LG,
        MEDIA_BREAKPOINTS.XL,
      ])
      .subscribe((state: BreakpointState) => {
        if (state.breakpoints[MEDIA_BREAKPOINTS.XL]) {
          this.latestRequestCols = 4;
          this.tamanho = 0;
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.LG]) {
          this.latestRequestCols = 4;
          this.tamanho = 0;
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.MD]) {
          this.latestRequestCols = 4;
          this.tamanho = 1;
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.SM]) {
          this.latestRequestCols = 6;
          this.tamanho = 2;
        } else if (state.breakpoints[MEDIA_BREAKPOINTS.XS]) {
          this.latestRequestCols = 12;
          this.tamanho = 2;
        } else {
          this.latestRequestCols = 6;
          this.tamanho = 2;
        }
        console.log(this.tamanho);
      });

    this.showRequestsCard = this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_LIST_LAST);
    this.showNewRequestCard =
      (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_REQUEST) &&
        (this.credentialsService.isDivisionAutos()
          ? this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_AUTOS)
          : this.authenticationService.permissionURL(URL_REQUESTS_REQUEST))) ||
      (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG_NO_SHOPPING)) ||
      (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG)) ||
      (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_BP)) ||
      (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_CG)) ||
      (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST));

    this.calculatorForm = this.formBuilder.group({
      establishment: ['', Validators.required],
      amountRequested: ['', Validators.required],
      deadline: ['', Validators.required],
      commercialProduct: ['', Validators.required],
      lineProduct: ['', Validators.required],
      entrance: ['', Validators.required],
    });

    this.calculatorForm.statusChanges.subscribe(() => {
      if (this.calculatorForm.valid) {
        this.buttonEnabled = true;
      } else {
        this.buttonEnabled = false;
      }
    });

    this.searchForm = this.formBuilder.group({
      requestNumber: ['', [this.customValidators.isOperationValid]],
      searchNif: ['', [this.customValidators.isNifOrCifValid]],
    });

    this.searchForm.statusChanges.subscribe(() => {
      if (
        ((!this.searchForm.controls.requestNumber.pristine &&
          this.searchForm.controls.requestNumber.value.length === 15) ||
          this.searchForm.controls.requestNumber.value.length === 7 ||
          (!this.searchForm.controls.searchNif.pristine && this.searchForm.controls.searchNif.valid)) &&
        (this.searchForm.controls.requestNumber.value || this.searchForm.controls.searchNif.value)
      ) {
        this.searchButtonEnabled = true;
      } else {
        this.searchButtonEnabled = false;
      }
    });

    //Carga de pantalla
    if (this.agentDTOUser.typeUser !== 'A' && this.showNewRequestCard) {
      this.loadOperationsMainPanel();
      // this.homeService.getEstablishment(this.agentDTOUser).subscribe(
      //   (data: CommonDataDTO[]) => {
      //     this.establishmentData = data;
      //     //seteado de combos si solo tienen un valor
      //     if (this.establishmentData.length === 1) {
      //       this.isLineCommercialFinishedLoading = false;
      //       this.calculatorForm.controls.establishment.setValue(this.establishmentData[0].id);
      //       this.onChangeEstablishment();
      //     }
      //     this.isEstablishmentFinishedLoading = true;
      //     this.changeLoadingStatus();
      //   },
      //   (error) => {
      //     // admin not have establishment
      //     if (this.agentDTOUser.typeUser !== 'A') {
      //       const dialogConfig = new MatDialogConfig();
      //       dialogConfig.width = '90%';
      //       dialogConfig.maxWidth = '450px';
      //       this.showDialogError(error, dialogConfig);
      //       this.isEstablishmentFinishedLoading = true;
      //       this.changeLoadingStatus();
      //     }
      //   }
      // );
    } else {
      //no se cargan, por lo que no hay que comprobar que se hayan cargado
      this.isEstablishmentFinishedLoading = true;
      this.isOperationsFinishedLoading = true;
    }

    this.changeLoadingStatus();
  }

  loadOperationsMainPanel(): void {
    const today: string = this.datePipe.transform(new Date(), DATE_FORMAT_YYYY_MM_DD);
    const ago = new Date(today);
    ago.setMonth(ago.getMonth() - 3);
    const dates: TotalsRequestDTO = {
      initialDate: this.datePipe.transform(ago, DATE_FORMAT_YYYY_MM_DD),
      finalDate: today,
    };
    this.homeService.getOperationsHome(dates).subscribe(
      (result: TotalOperationsDTO[]) => {
        let resultAux: TotalOperationsDTO[] = new Array();

        //Reordenar la lista de operacines
        result.forEach((operationStatus) => {
          if (operationStatus.status === PENDIENTES_DE_DATOS) {
            resultAux[0] = operationStatus;
          } else if (operationStatus.status === EN_ESTUDIO) {
            resultAux[1] = operationStatus;
          } else if (operationStatus.status === APROBADAS) {
            resultAux[2] = operationStatus;
          } else if (operationStatus.status === FIRMADAS) {
            resultAux[3] = operationStatus;
          } else if (operationStatus.status === FORMALIZADAS_ABONADAS_VALIDADAS) {
            resultAux[4] = operationStatus;
          } else if (operationStatus.status === PENDIENTES_PAGO_POR_INCIDENCIAS) {
            resultAux[5] = operationStatus;
          } else if (operationStatus.status === ABONADAS_PENDIENTES_DE_VALIDACION) {
            resultAux[6] = operationStatus;
          }
        });

        resultAux.forEach((element) => {
          let homeObject: HomeObject = {
            id: '',
            nameStatus: '',
            style: '',
            requestsData: { status: '', totalOperations: 0 },
          };
          homeObject.requestsData = {
            status: element.status,
            totalOperations: element.totalOperations,
          };
          switch (element.status) {
            case '00':
              homeObject.id = 'pendingButtonHome';
              homeObject.style = 'circle--pending';
              homeObject.nameStatus = 'home.chip.pending';
              break;
            case 'PA':
              homeObject.id = 'approvedButtonHome';
              homeObject.style = 'circle--approved';
              homeObject.nameStatus = 'home.chip.approve';
              break;
            case 'PE':
              homeObject.id = 'studyButtonHome';
              homeObject.style = 'circle--study';
              homeObject.nameStatus = 'home.chip.study';
              break;
            case '90':
              homeObject.id = 'formalizedButtonHome';
              homeObject.style = 'circle--formalized';
              homeObject.nameStatus = 'home.chip.formalise';
              break;
            case '15':
              homeObject.id = 'pending-incidentsButtonHome';
              homeObject.style = 'circle--pending-incidents';
              homeObject.nameStatus = 'home.chip.pending.bug';
              break;
            case 'PF':
              homeObject.id = 'signedButtonHome';
              homeObject.style = 'circle--signed';
              homeObject.nameStatus = 'home.chip.signed';
              break;
            default:
              console.error('No se ha encontrado estado de solicitudes');
              //TODO: remove
              this.loaderGenericService.stopSpinner();
              break;
          }
          if (homeObject.requestsData.status !== 'PV') {
            this.buttonsList.push(homeObject);
          }
          this.isOperationsFinishedLoading = true;
          this.changeLoadingStatus();
        });
      },
      (error) => {
        let credentials: Credentials = JSON.parse(localStorage.getItem('credentials'));
        if (credentials.userType !== 'T') {
          console.error(error);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '450px';
          dialogConfig.data = { text: error.error?.message };
          this.showDialogError(error, dialogConfig);
          this.isOperationsFinishedLoading = true;
          this.changeLoadingStatus();
        }
      }
    );
  }

  latestResquests(element: HomeObject) {
    //guardar los datos en el store para que el panel pueda cargarlos
    this.panelStore.setFilterStatus({ state: element.requestsData.status, initialDate: '', finalDate: '' });
    this.router.navigate(['/requests/panel', { keepFilter: true }]);
  }

  showAllRequests() {
    this.router.navigate(['/requests/panel' /*, { keepFilter: false }*/]);
  }

  onChangeEstablishment() {
    //cargamos producto comercial y linea de producto
    if (this.calculatorForm.controls.establishment.value) {
      forkJoin([
        this.combosStore.loadLineProduct(
          this.userInfo.userType === 'V' ? this.userInfo.parentId : this.userInfo.userId
        ),
        this.combosStore.loadCommercialProduct(this.calculatorForm.controls.establishment.value, ''),
      ]).subscribe(
        (respuestaFork: any) => {
          this.lineProductList = respuestaFork[0];
          this.commercialProductList = respuestaFork[1];

          //seteado de combos si solo tienen un valor
          if (this.lineProductList.length === 1) {
            this.calculatorForm.controls.lineProduct.setValue(this.lineProductList[0].id);
          }
          if (this.commercialProductList.length === 1) {
            this.calculatorForm.controls.commercialProduct.setValue(this.commercialProductList[0].id);
          }
          this.isLineCommercialFinishedLoading = true;
          this.changeLoadingStatus();
        },
        (error) => {
          console.error('Error get request', error);
          this.isLineCommercialFinishedLoading = true;
          this.changeLoadingStatus();
        }
      );
    } else {
      this.isLineCommercialFinishedLoading = true;
      this.changeLoadingStatus();
    }
  }

  goToCalculator() {
    console.log('calculadora');
  }

  redirectToNewRequest() {
    //comprobar las atribuciones del usuario y en funcion de las que tenga redirigir a una pagina de alta o a otra
    //TODO: REVISAR ESTE CASO -> ¿NO SE SUPONE QUE SI NO TIENEN LA ATRIBUCION DE DAR DE ALTA OPERACIONES NO DEBERIAN PODER DARLAS?
    // EJEMPLO: AINHOA NO TIENE ATRIBUCION 002 QUE ES LA DE DAR DE ALTA, Y SIN EMBARGO PUEDE DAR DE ALTA
    if (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) &&
      this.authenticationService.permissionURL('/requests/request-bp')
    ) {
      //redirect to alta BP
      this.router.navigate(['/requests/request-bp'], { replaceUrl: true });
    } else if (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) &&
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) &&
      this.authenticationService.permissionURL('/requests/request-mg-no-shopping') &&
      this.authenticationService.permissionURL('/requests/request-mg')
    ) {
      //redirect to alta mg compra
      this.router.navigate(['/requests/request-mg'], { replaceUrl: true });
    } else if (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_REQUEST) &&
      (this.authenticationService.permissionURL('/requests/request') ||
        this.authenticationService.permissionURL('/requests/request-auto'))
    ) {
      //vemos si es autos o consumo
      if (this.credentialsService.isDivisionAutos()) {
        //redirect to autos
        this.router.navigate(['/requests/request-auto'], { replaceUrl: true });
      } else {
        //redirect to consumo?
        this.router.navigate(['/requests/request'], { replaceUrl: true });
      }
    } else if (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS) &&
      this.authenticationService.permissionURL('/requests/request')
    ) {
      //redirect to gasoleo
      this.router.navigate(['/requests/request'], { replaceUrl: true });
    } else if (
      this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) &&
      this.authenticationService.permissionURL('/requests/request')
    ) {
      // redirect to repsol
      this.router.navigate(['/requests/request'], { replaceUrl: true });
    }
  }

  searchRequest() {
    const numOperation = this.searchForm.controls.requestNumber.value
      ? this.searchForm.controls.requestNumber.value
      : '';
    const nifNie = this.searchForm.controls.searchNif.value ? this.searchForm.controls.searchNif.value : '';
    if (numOperation || nifNie) {
      //redirigir al buscador pero mandando los datos
      this.searchStore.setSearchCriteria({ operation: numOperation, nif_nie: nifNie });
      this.router.navigate(['/users/search-operation', { keepFilter: true }]);
    }
  }

  numberOnlySearch(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.searchForm.controls[inputForm].value;

    let returnBoolean = this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
    if (value.length >= 15) {
      returnBoolean = false;
    }

    return returnBoolean;
  }

  numberOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.calculatorForm.controls[inputForm].value;

    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
  }

  transformAmount(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;

    this.calculatorForm.controls[inputForm].setValue(this.customValidators.transformAmount(inputValue));
  }

  private showDialogError(error: any, dialogConfig: MatDialogConfig) {
    console.log(error);
    let errorDescription: string = error.error.message;
    let errorField = '';
    if (errorDescription && errorDescription.includes('Error resolving template')) {
      if (error?.error?.errors[0].field.includes('participant')) {
        let errors = error?.error?.errors[0].field.split('.', 2);
        errorField = this.translate.instant(errors[0]).concat(' ', this.translate.instant(errors[1]));
      } else {
        errorField = this.translate.instant(error?.error?.errors[0].field);
      }
      errorDescription = this.translate.instant('dialog.response.textFormatError', {
        field: errorField,
      });
    } else {
      errorDescription = this.translate.instant('error.pagina_403');
    }

    dialogConfig.data = {
      text: dialogConfig.data?.text ? dialogConfig.data?.text : errorDescription,
      icon: 'icon-ic_circle_cross',
    };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  private changeLoadingStatus(): void {
    if (
      this.isOperationsFinishedLoading &&
      // this.isEstablishmentFinishedLoading &&
      this.isLineCommercialFinishedLoading
    ) {
      this.loaderGenericService.stopSpinner();
    }
  }
}
